"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProcessSpotBalance = exports.createSpotOrderAPI = exports.useSpotTradeParams = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const errors_1 = require("../../../interface/errors");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const CustomAssetsProvider_1 = require("../../CustomAssetsProvider");
const CheckSpotRequest_1 = require("./CheckSpotRequest");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const useSpotTradeParams = (props) => {
    const { accountType, symbolInfo, orderSide, orderType, investSide, price, invest, curPrice, isFocused, leveragedCoinAccountQuota, leveragedCoinQuota, customBalanceObservable, } = props;
    const { baseBalance, quoteBalance, baseTotal } = (0, exports.useProcessSpotBalance)(accountType, symbolInfo, isFocused, customBalanceObservable);
    const isBuy = orderSide === interface_1.CustomOrderSide.BUY;
    const [available, canBuy, volume, amount] = (() => {
        const limitPriceD = new trade_utils_lib_1.SafeDecimal(price);
        const curPriceD = new trade_utils_lib_1.SafeDecimal(curPrice);
        // 可用余额 买为base, 卖为quote
        const availD = new trade_utils_lib_1.SafeDecimal(isBuy ? quoteBalance : baseBalance);
        const availStr = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(availD, isBuy ? symbolInfo.precision : symbolInfo.amount);
        // 计算可投
        let cb = "";
        if (orderType === interface_1.CustomOrderType.LIMIT) {
            if (orderSide === interface_1.CustomOrderSide.BUY) {
                if (investSide === interface_1.InvestSymbolSide.base) {
                    if (limitPriceD.equals(0) === false) {
                        // 限价 买 投base, availD为quote. cb = quote/价格
                        cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(availD.div(limitPriceD), symbolInfo.amount);
                    }
                }
                else {
                    // 限价 买 投quote, availD为quote. cb = quote
                    cb = availStr;
                }
            }
            else {
                if (investSide === interface_1.InvestSymbolSide.base) {
                    // 限价 卖 投base, availD为base. cb = base
                    cb = availStr;
                }
                else {
                    if (limitPriceD.equals(0) === false) {
                        // 限价 卖 投quote, availD为base. cb = base*价格
                        cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(availD.mul(limitPriceD), symbolInfo.amount);
                    }
                }
            }
        }
        else if (orderType === interface_1.CustomOrderType.MARKET) {
            cb = availStr;
        }
        // 计算成交额
        let _volume = "";
        // 计算成交量
        let _amount = "";
        const investD = new trade_utils_lib_1.SafeDecimal(invest);
        if (Number(invest)) {
            if (orderType === interface_1.CustomOrderType.LIMIT && limitPriceD.equals(0) === false) {
                if (investSide === interface_1.InvestSymbolSide.base) {
                    _amount = invest;
                    _volume = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(limitPriceD.mul(investD), symbolInfo.precision);
                }
                else {
                    _amount = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(investD.div(limitPriceD), symbolInfo.amount);
                    _volume = invest;
                }
            }
            else if (orderType === interface_1.CustomOrderType.MARKET && curPriceD.equals(0) === false) {
                if (orderSide === interface_1.CustomOrderSide.BUY) {
                    _amount = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(investD.div(curPriceD), symbolInfo.amount);
                    _volume = invest;
                }
                else {
                    _amount = invest;
                    _volume = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(investD.mul(curPriceD), symbolInfo.precision);
                }
            }
        }
        return [availStr, cb, _volume, _amount];
    })();
    const createOrder = (0, react_1.useCallback)((curPrice) => {
        if (!curPrice) {
            return (0, rxjs_1.throwError)(errors_1.TRADE_NO_CURRENT_PRICE);
        }
        return (0, CheckSpotRequest_1.createSpotOrder)({
            accountType: accountType,
            symbol: symbolInfo,
            orderType: orderType,
            side: orderSide,
            investSide: investSide,
            available: available,
            canBuy: canBuy,
            price: price,
            curPrice: curPrice,
            invest: invest,
            volume: volume,
            baseTotal: baseTotal,
            leveragedCoinQuota: leveragedCoinQuota,
            leveragedCoinAccountQuota: leveragedCoinAccountQuota,
        });
    }, [
        accountType,
        symbolInfo,
        orderType,
        orderSide,
        investSide,
        available,
        canBuy,
        price,
        invest,
        volume,
        baseTotal,
        leveragedCoinQuota,
        leveragedCoinAccountQuota,
    ]);
    return {
        createOrder: createOrder,
        available: available,
        canBuy: canBuy,
        volume: volume,
        amount: amount,
    };
};
exports.useSpotTradeParams = useSpotTradeParams;
const createSpotOrderAPI = (request) => {
    return (0, FutureAPI_1.postCustomOrder)(request);
};
exports.createSpotOrderAPI = createSpotOrderAPI;
/**
 * bot 账户应该使用自定义的balance订阅方案, 不能使用默认的account detail的接口
 * @param accountType
 * @param symbolInfo
 * @param isFocused
 * @param customBalanceObservable
 */
const useProcessSpotBalance = (accountType, symbolInfo, isFocused, customBalanceObservable) => {
    const isUseCustomBalance = customBalanceObservable !== undefined;
    const { baseBalance: FBBase, quoteBalance: FBQuote } = (0, CustomAssetsProvider_1.useFPBalanceInfo)(accountType, symbolInfo.base, symbolInfo.quote, !isUseCustomBalance && isFocused);
    const customBalance = useCustomBalance(symbolInfo, isFocused, customBalanceObservable);
    const { baseBalance, quoteBalance, baseTotal } = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e;
        if (isUseCustomBalance) {
            return {
                baseBalance: (_a = customBalance === null || customBalance === void 0 ? void 0 : customBalance.baseBalance) !== null && _a !== void 0 ? _a : "",
                quoteBalance: (_b = customBalance === null || customBalance === void 0 ? void 0 : customBalance.quoteBalance) !== null && _b !== void 0 ? _b : "",
                baseTotal: (_c = customBalance === null || customBalance === void 0 ? void 0 : customBalance.baseTotal) !== null && _c !== void 0 ? _c : "",
            };
        }
        else {
            return { baseBalance: (_d = FBBase === null || FBBase === void 0 ? void 0 : FBBase.transferable) !== null && _d !== void 0 ? _d : "", quoteBalance: (_e = FBQuote === null || FBQuote === void 0 ? void 0 : FBQuote.transferable) !== null && _e !== void 0 ? _e : "", baseTotal: FBBase === null || FBBase === void 0 ? void 0 : FBBase.assets };
        }
    }, [
        FBBase === null || FBBase === void 0 ? void 0 : FBBase.assets,
        FBBase === null || FBBase === void 0 ? void 0 : FBBase.transferable,
        FBQuote === null || FBQuote === void 0 ? void 0 : FBQuote.transferable,
        customBalance === null || customBalance === void 0 ? void 0 : customBalance.baseBalance,
        customBalance === null || customBalance === void 0 ? void 0 : customBalance.baseTotal,
        customBalance === null || customBalance === void 0 ? void 0 : customBalance.quoteBalance,
        isUseCustomBalance,
    ]);
    if (accountType === trade_utils_lib_1.AccountTradeType.bot && !customBalanceObservable) {
        throw "!!!! bot 账户应该使用自定义的balance订阅方案, 不能使用 account detail的接口";
    }
    return { baseBalance, quoteBalance, baseTotal };
};
exports.useProcessSpotBalance = useProcessSpotBalance;
const useCustomBalance = (symbolInfo, isFocused, obFunc) => {
    const [customBalance, setCustomBalance] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!obFunc || !isFocused) {
            return;
        }
        const sub = obFunc(symbolInfo.base, symbolInfo.quote).subscribe({
            next: (data) => {
                setCustomBalance(data);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [obFunc, symbolInfo.base, symbolInfo.quote, isFocused]);
    return customBalance;
};
